/*
 * Master Roles loader — single source of truth for the Future-Ready Career Previews.
 * Data: served via /api/content/master-roles.json (auth-gated). Falls back to /data/.
 * Meta: /api/content/master-roles-meta.json (public).
 */
import { loadContent } from './contentLoader';

let fullPromise = null;
let metaPromise = null;

export const loadMasterMeta = () => {
  if (!metaPromise) {
    metaPromise = loadContent('master-roles-meta.json', { authRequired: false });
  }
  return metaPromise;
};

export const loadMasterRoles = () => {
  if (!fullPromise) {
    fullPromise = loadContent('master-roles.json');
  }
  return fullPromise;
};

export const findRoleByCatalogNumber = (dataset, catalogNumber) => {
  if (!dataset?.previews) return null;
  return dataset.previews.find(
    (r) => String(r.catalog_number) === String(catalogNumber),
  ) || null;
};

export const groupBySections = (previews) => {
  const map = new Map();
  previews.forEach((r) => {
    const sec = r.section || 'Other';
    if (!map.has(sec)) map.set(sec, []);
    map.get(sec).push(r);
  });
  return Array.from(map.entries()).map(([name, roles]) => ({
    name,
    count: roles.length,
    roles,
  }));
};

export const searchPreviews = (previews, query) => {
  if (!query?.trim()) return previews;
  const q = query.toLowerCase();
  return previews.filter((r) => {
    const fields = [
      r.role_name,
      r.title,
      r.section,
      r.ai_impact_note,
      ...(r.tags || []),
      ...(r.subtitle || []),
      r.shift_in_one_scene,
      ...(r.if_you_read_nothing_else || []),
    ];
    return fields.some((f) => typeof f === 'string' && f.toLowerCase().includes(q));
  });
};

export const sortByCatalogNumber = (previews) =>
  [...previews].sort((a, b) => (a.catalog_number || 0) - (b.catalog_number || 0));
